import { setGlobal, getGlobal } from "reactn";
import { FetchStatus } from "js/react/constants";
import { ds } from "js/core/models/dataService";

class teamsDS {
    static initializeStore() {
        setGlobal({
            presentationTeams: {
                status: {
                    type: FetchStatus.UNSET
                },
                teams: []
            }
        });
    }

    static async fetchTeams(next) {
        if (next) {
            setGlobal({
                presentationTeams: {
                    ...getGlobal().presentationTeams,
                    status: {
                        type: FetchStatus.LOADING_MORE
                    }
                }
            });
        } else {
            setGlobal({
                presentationTeams: {
                    status: {
                        type: FetchStatus.LOADING
                    },
                    teams: []
                }
            });
        }

        const query = { id: getGlobal().presentation.id };
        if (next) {
            query.next = next;
        }

        try {
            ds.teams.loadModels().then(() => {
                setGlobal({
                    presentationTeams: {
                        status: {
                            type: FetchStatus.SUCCESS
                        },
                        teams: ds.teams.models
                    }
                });
            });
        } catch (err) {
            setGlobal({
                presentationTeams: {
                    status: {
                        type: FetchStatus.ERROR,
                        message: err.message
                    }
                }
            });
        }
    }
}

ds.registerDataService(teamsDS.initializeStore, "presentation");

export default teamsDS;
